import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { jeeAdvancedPackages, jeePackages, neetPackages } from '@app-constants/app.constants';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { dashboardRoute } from '@app-constants/app.constants';
import { navigateBetweenProjects } from 'src/app/helpers/functions';
import { TestlistService } from '@app-services/test/testlist.service';

export function navigateToDashboard() {
  this.testListService?.clearApisData();
  let selectedTab = localStorage.getItem('SelectedTab')
  const route = dashboardRoute + (selectedTab == 'liveclass' ? '/liveclass' : '/assessment');
  navigateBetweenProjects(this.router, route);
}

@Component({
  selector: 'app-congrajulations',
  templateUrl: './congrajulations.component.html',
  styleUrls: ['./congrajulations.component.css']
})
export class CongrajulationsComponent implements OnInit {
  navigateToDashboard = navigateToDashboard;
  public congratulationsutility :any = {
    status :''
  };
  selectedPkg: any;
  public neetPackages:any[] = neetPackages;
  public jeePackages:any[] = jeePackages;
  public jeeAdvancedPackages:any[] = jeeAdvancedPackages;
  constructor(public router: Router,public SubscriptionService: SubscriptionService, private testListService: TestlistService) { 
    
     this.congratulationsutility = this.router.getCurrentNavigation()?.extras?.state
     console.log('this.congratulationsutility : ', this.congratulationsutility );
     if(this.congratulationsutility?.status == undefined && !this.congratulationsutility?.detailsEntered) {
      this.router.navigateByUrl('/ilite');
      return;
     }
     this.congratulationsutility.status = 'success';
  }

  ngOnInit(): void {
    [this.neetPackages, this.jeePackages, this.jeeAdvancedPackages].some(pkgArr => {
      const findPkg = pkgArr.find(pkg => {
        if(pkg.grade.replaceAll(" ", "").toUpperCase() == this.congratulationsutility?.grade?.replaceAll(" ", "")?.toUpperCase()) {
          if(pkg.examName.replaceAll(" ", "").toUpperCase() == this.congratulationsutility?.exam?.replaceAll(" ", "")?.toUpperCase()) {
            return true;
          }
        }
      });
      if(findPkg) {
        return this.selectedPkg = findPkg;
      }
    })
    if(!this.selectedPkg) {
      this.selectedPkg = this.jeeAdvancedPackages[0];
    }
  }

  downloadInvoice(){
    this.SubscriptionService.downloadInvoice(this.congratulationsutility?.payment?.userOrder?.id).subscribe((resp)=>{
      const a = document.createElement('a')
      const objectUrl = URL.createObjectURL(resp)
      a.href = objectUrl
      a.download = (this.congratulationsutility?.examName ? this.congratulationsutility?.examName : this.congratulationsutility?.exam ? this.congratulationsutility?.exam  : "ILITETest") +'invoice';
      a.click();
      URL.revokeObjectURL(objectUrl)
    })
  } 
}
